export const cyan = 'rgba(0,139,208,1)';
export const white = 'rgba(255,255,255,1)';
export const whiteSmoke = 'rgba(239,239,239,1)';
export const whiterSmoke = 'rgba(248,248,248,1)';
export const lighterGray = 'rgba(211,211,211,1)';
export const tuna = 'rgba(75,78,82,1)';
export const eclipse = 'rgba(62,62,62,1)';
export const charcoal = 'rgba(114,114,114,1)';
export const pinkSwan = 'rgba(180,180,180,1)';
export const transparent = 'rgba(255, 255, 255, 0)';
export const black = 'rgba(0,0,0,1)';
export const steel = 'rgba(116,118,120,1)';
export const teal = 'rgba(77,144,161,1)';
export const blue = 'rgba(0,94,210,1)';
export const darkGray = 'rgba(132,132,132,1)';
export const dark = 'rgba(64,64,64,1)';
export const pacificBlue = cyan;
export const grey1 = 'rgba(77,79,83,1)';
export const grey2 = 'rgba(116,118,120,1)';
export const grey3 = 'rgba(139,141,142,1)';
export const grey4 = 'rgba(154,155,156,1)';
export const grey5 = 'rgba(188,189,188,1)';
export const grey6 = 'rgba(224,225,221,1)';
export const grey6m = 'rgba(223,227,230,1)';
export const grey7 = 'rgba(242,242,242,1)';
export const brightBlue = 'rgba(235,240,247,1)';
export const lightGray = 'rgba(178,178,178,1)';
export const disabledBlue = 'rgba(203,228,245,1)';
export const indigo = 'rgba(20,30,140,1)';
export const azur = 'rgba(5,94,210,1)';
export const azur1 = '#9bbeed';
export const azur2 = '#699ee4';
export const azur3 = '#377edb';
export const azur4 = '#044ba8';
export const azur5 = '#03387e';
export const azur6 = '#022554';
export const skyBlue = 'rgba(106,176,226,1)';
export const skyBlue1 = '#c3dff3';
export const skyBlue2 = '#a5cfed';
export const skyBlue3 = '#87bfe7';
export const skyBlue4 = '#548cb4';
export const skyBlue5 = '#3f6987';
export const skyBlue6 = '#2a465a';
export const green = 'rgba(60,138,46,1)';
export const green1 = '#b1d0ab';
export const green2 = '#8ab881';
export const green3 = '#63a157';
export const green4 = '#306e24';
export const green5 = '#24521b';
export const green6 = '#183712';
export const greenNeon = 'rgba(225,255,50,1)';
export const lightGreen = 'rgba(217,233,6,1)';
export const brightLemon = 'rgba(254,203,0,1)';
export const orange = 'rgba(236,101,0,1)';
export const orange1 = '#f7c199';
export const orange2 = '#f3a266';
export const orange3 = '#ef8333';
export const orange4 = '#bc5000';
export const orange5 = '#8d3c00';
export const orange6 = '#5e5800';
export const orangeNeon = 'rgba(255,26,0,1)';
export const red1 = '#ffa399';
export const red2 = '#ff7566';
export const red3 = '#ff4733';
export const red4 = '#cc1400';
export const red5 = '#990f00';
export const red6 = '#660a00';
export const purpleRed = 'rgba(167,2,64,1)';
export const purpleRed1 = '#edccd9';
export const purpleRed2 = '#d381a0';
export const purpleRed3 = '#b93566';
export const purpleRed4 = '#96023a';
export const purpleRed5 = '#75012d';
export const purpleRed6 = '#43011a';
export const midnight = 'rgba(0,80,123,1)';
export const ocean = 'rgba(0,102,156,1)';
export const all = {
  cyan,
  white,
  whiteSmoke,
  whiterSmoke,
  lighterGray,
  tuna,
  eclipse,
  charcoal,
  pinkSwan,
  transparent,
  black,
  steel,
  teal,
  blue,
  darkGray,
  dark,
  pacificBlue,
  grey1,
  grey2,
  grey3,
  grey4,
  grey5,
  grey6,
  grey6m,
  grey7,
  brightBlue,
  lightGray,
  disabledBlue,
  indigo,
  azur,
  azur1,
  azur2,
  azur3,
  azur4,
  azur5,
  azur6,
  skyBlue,
  skyBlue1,
  skyBlue2,
  skyBlue3,
  skyBlue4,
  skyBlue5,
  skyBlue6,
  green,
  green1,
  green2,
  green3,
  green4,
  green5,
  green6,
  greenNeon,
  lightGreen,
  brightLemon,
  orange,
  orange1,
  orange2,
  orange3,
  orange4,
  orange5,
  orange6,
  orangeNeon,
  red1,
  red2,
  red3,
  red4,
  red5,
  red6,
  purpleRed,
  purpleRed1,
  purpleRed2,
  purpleRed3,
  purpleRed4,
  purpleRed5,
  purpleRed6,
  midnight,
  ocean,
};
